import { createContext, useState, useEffect } from 'react'

export type Config = {
  REACT_APP_AWS_COGNITO_USER_POOL_ID: string,
  REACT_APP_AWS_COGNITO_CLIENT_ID: string,
  REACT_APP_AWS_SOCKET: string,
  REACT_APP_DOMAIN: string,
  REACT_APP_AWS_COGNITO_LOGOUT_URI: string,
  REACT_APP_IDLE_TIMEOUT: string,
  REACT_APP_AWS_COGNITO_USER_POOL_AUTH_TOKEN: string,
  REACT_APP_AWS_COGNITO_REDIRECT_URI: string,
  REACT_APP_AWS_COGNITO_OAUTH_RESPONSE_TYPE: string,
  REACT_APP_WARNING_DURATION: string,
  REACT_APP_PING_INTERVAL_IN_MS: string
}

const INITIAL_STATE: Config = {
  REACT_APP_AWS_COGNITO_USER_POOL_ID: '',
  REACT_APP_AWS_COGNITO_CLIENT_ID: '',
  REACT_APP_AWS_SOCKET: '',
  REACT_APP_DOMAIN: '',
  REACT_APP_AWS_COGNITO_LOGOUT_URI: '',
  REACT_APP_IDLE_TIMEOUT: '',
  REACT_APP_AWS_COGNITO_USER_POOL_AUTH_TOKEN: '',
  REACT_APP_AWS_COGNITO_REDIRECT_URI: '',
  REACT_APP_AWS_COGNITO_OAUTH_RESPONSE_TYPE: '',
  REACT_APP_WARNING_DURATION: '',
  REACT_APP_PING_INTERVAL_IN_MS: ''
}
export const ConfigContext = createContext(INITIAL_STATE)

export const ConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null)
  /*@ts-ignore*/
  useEffect(() => {
    fetch('/config.json')
      .then((response) => response.json())
      .then((configData) => {
        /*@ts-ignore*/
        if (window?.brand === 'nab') {
          configData.REACT_APP_AWS_COGNITO_REDIRECT_URI = `${configData.REACT_APP_DOMAIN}/nab_customer.html`
        }
        setConfig(configData)
      })
  }, [])

  // While the config is not loaded, you can show a loading indicator or return null
  if (!config) {
    return <div>Loading configuration...</div>
  }

  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
}
